import { Tag } from '@acies/domain';

export default class TagRendererEvent extends Event {
	public static CLOSE = 'TagRendererEvent.close';

	public get tag(): Tag {
		return this.#tag;
	}

	#tag: Tag;

	public constructor(tag: Tag) {
		super(TagRendererEvent.CLOSE, { bubbles: true });
		assertIsTag(tag);
		this.#tag = tag;
	}
}

function assertIsTag(value: unknown): asserts value is Tag {
	if (value instanceof Tag) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be of type Tag`);
}
